<template>
  <div>
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <form class="needs-validation"
              @submit.prevent="handleSubmit(formSubmit)">
          <div class="form-row">
            <div class="col-md-8">
              <base-input
                type="text"
                v-model="model.title"
                rules="required|max:250"
                :name="$t('Title')"
                :label="$t('Title')"
                labelClasses="required form-control-label"
              >
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input
                :name="$t('taskForm.types.form.description.label')"
                :label="$t('taskForm.types.form.description.label')">
                <textarea
                  class="form-control"
                  rows="5"
                  v-model="model.description">
                  </textarea>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input :label="$t('taskForm.types.form.textSuccess.label')"
                          :name="$t('taskForm.types.form.textSuccess.label')">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="model.textSuccess">
                </textarea>
                <template v-slot:infoBlock>
                  <small>{{ $t('taskForm.types.form.textSuccess.infoBlock') }}</small>
                </template>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input :name="$t('taskForm.types.form.textThankyou.label')"
                          :label="$t('taskForm.types.form.textThankyou.label')">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="model.textThankyou">
                </textarea>
                <template v-slot:infoBlock>
                  <small>{{ $t('taskForm.types.form.textThankyou.infoBlock') }}</small>
                </template>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <base-checkbox class="mb-3" v-model="model.required">
                {{ $t('This task should be done to continue course') }}
              </base-checkbox>
            </div>
          </div>
          <div class="form-row mt-4">
            <div class="col-md-4">
              <base-checkbox class="mb-3" v-model="model.needReview">
                {{ $t('Required in checking home work?') }}
              </base-checkbox>
            </div>
          </div>
          <base-button
            type="primary"
            :loading="loading"
            native-type="submit">
            {{ $t('Save task') }}
          </base-button>
        </form>
      </validation-observer>
    </v-wait>
  </div>
</template>


<script>
  import {createNamespacedHelpers} from 'vuex';
  import {TaskForm} from "../../../mixins/Task/TaskForm";
  import {FormEdit, FormNotification, FormSubmitHandlers} from "../../../mixins/FormApiHandlers";
  import FormGenerator from "../../../components/FormGenerator/FormGenerator";
  import Spinner from 'vue-spinner-component/src/Spinner';

  const {mapActions, mapState} = createNamespacedHelpers('course/task');

  export default {
    name: "FormEditTaskTypeAnswer",
    components: {FormGenerator, Spinner},
    data() {
      return {
        taskType: 'answer',
        successMessage: this.$i18n.t('You are update task info!'),
        errorMessage: this.$i18n.t('Error on updating task info!'),
        submitRedirectTo: {name: 'content', params: this.$route.params},
        waiterKeyword: 'task data fetching'
      }
    },
    mixins: [TaskForm, FormNotification, FormSubmitHandlers, FormEdit],
    computed: {
      ...mapState({
        vuexModel: state => state.currentTask,
        status: state => state.updateStatus.status
      }),
      form() {
        return {
          ...this.model,
          lessonId: this.$route.params.lessonId
        }
      }
    },
    methods: {
      formSubmit() {
        this.save({
          urlParams: {...this.$route.params, type: this.taskType},
          form: this.form
        });
      },
      ...mapActions({
        load: 'loadTask',
        save: 'saveTask',
        revertStatus: 'revertCreateStatus'
      })
    }
  }
</script>

<style scoped lang="scss">
</style>
